import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Box } from '@mui/system';
import { useSTColumn } from '../SmartTableContext';
import { defineStyles } from '../../theme';
import { SortType } from '../../api/generated';
const styles = defineStyles({
    root: {
        width: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'width 0.2s ease',
        cursor: 'pointer',
    },
});
function TableHeaderSort({ cell, onClickSort }) {
    const { columnSortingInfo, isOnlySorting, columnSortingIndex } = useSTColumn(cell);
    return (_jsxs(Box, { sx: {
            ...styles.root,
            ...(columnSortingInfo && { width: 24, ml: 1 }),
        }, onClick: onClickSort, children: [_jsx(TableHeaderSortIcon, { direction: columnSortingInfo?.direction }), !isOnlySorting && columnSortingIndex !== -1 && columnSortingIndex + 1] }));
}
function TableHeaderSortIcon({ direction }) {
    if (direction === SortType.Asc)
        return _jsx(ArrowDropUpIcon, {});
    if (direction === SortType.Desc)
        return _jsx(ArrowDropDownIcon, {});
    return null;
}
export default TableHeaderSort;
//# sourceMappingURL=TableHeaderSort.js.map